import { render, staticRenderFns } from "./NumberFlip.vue?vue&type=template&id=afb81456&scoped=true&"
import script from "./NumberFlip.vue?vue&type=script&lang=js&"
export * from "./NumberFlip.vue?vue&type=script&lang=js&"
import style0 from "./NumberFlip.vue?vue&type=style&index=0&id=afb81456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb81456",
  null
  
)

export default component.exports